import { Avatar } from '@material-ui/core';
import * as React from 'react';
import { PureComponent } from 'react';

const styles = require('./styles.less');

export interface IMapViewProps {
  id?: string;
  zoom: number;
  center: ILngLat;
  editable: boolean;
  pressingAltKey: string;
  minEditableZoom: number;
  onContainerMounted?: IFunction;
}

export default class MapView extends PureComponent<IMapViewProps> {

  public static defaultProps = {
    onContainerMounted: () => null,
  };

  public componentDidMount() {
    const { onContainerMounted } = this.props;
    onContainerMounted!();
  }

  public render() {
    const { id, zoom, center, editable, pressingAltKey, minEditableZoom } = this.props;
    return (
      <div style={{ width: '100%', position: 'relative' }}>
        <div className={styles.map} style={{ zoom: '133%' }} id={id}/>
        <div
          style={{
            position: 'absolute',
            width: '100%',
            background: 'rgba(255,255,255,.5)',
            height: 40,
            left: 0,
            top: 0,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <span style={{ margin: '0 5px' }}>缩放:{zoom.toFixed(2)}</span>
          <span
            style={{ margin: '0 5px' }}
          >中心点:{center.map(item => item.toFixed(2)).join(',')}
          </span>
          <span style={{ margin: '0 5px' }}>【全局】{editable ? '可编辑' : '不可编辑'}</span>
          <span
            style={{ margin: '0 5px' }}
          >【全局】{pressingAltKey ? '不可吸附' : '可吸附'}(长按 Alt/Options)
          </span>
          <span style={{ margin: '0 5px' }}>(Space切换，Zoom {minEditableZoom}以上可开启编辑)</span>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/views/MapView.tsx